import clsx from 'clsx';
import { useTranslation } from 'next-i18next/pages';
import { StaticImageData } from 'next/image';
import { twMerge } from 'tailwind-merge';

import ButtonLink from '../../button-link/ButtonLink';
import { getButtonClassName } from '../../button/Button.component';
import HowItWorksCtaImage from './HowItWorksCTAImage.component';

interface HowItWorksCtaProps {
  employerLayout?: boolean;
  desktopImage: StaticImageData | string;
  mobileImage: StaticImageData | string;
  onClick?: () => void;
  title?: string;
  // We must use titleClasses to override where the text color should be different than default
  titleClasses?: string;
  subtitle?: string;
  guestContent?: React.ReactElement;
  href?: string;
  altDesktopImage?: string;
  altMobileImage?: string;
}

// TODO-WM: pass the button label as prop
const HowItWorksCta: React.FC<HowItWorksCtaProps> = ({
  employerLayout = false,
  desktopImage,
  mobileImage,
  altDesktopImage,
  altMobileImage,
  href = '#',
  onClick,
  title,
  titleClasses,
  subtitle,
  guestContent,
}) => {
  const { t } = useTranslation('landingPage', { keyPrefix: `howItWorks.${employerLayout ? 'employer' : 'guest'}.ctaCard` });
  return (
    <div className='flex flex-col-reverse items-center lg:flex-row lg:items-center'>
      <HowItWorksCtaImage
        desktopImage={desktopImage}
        mobileImage={mobileImage}
        altDesktopImage={altDesktopImage}
        altMobileImage={altMobileImage}
      />
      <div className='mb-6 flex h-min w-full flex-col rounded-2xl border-2 border-gray-100 bg-white p-6 shadow-lg lg:mt-28 lg:ml-2'>
        {employerLayout ? (
          <>
            {title && <h3 className={twMerge(clsx('mb-4 text-xl font-medium lg:text-3xl', titleClasses))}>{title}</h3>}
            {subtitle && <p className='text-sm lg:text-lg'>{subtitle}</p>}
          </>
        ) : (
          <p>{guestContent}</p>
        )}
        <ButtonLink href={href} className={getButtonClassName('primary', 'mt-2 ml-auto w-36 min-w-fit')} onClick={onClick}>
          {t('button')}
        </ButtonLink>
      </div>
    </div>
  );
};

export default HowItWorksCta;
